import { useCallback, useEffect, useState } from "react";

export function useDimensions() {
  const hasWindow = typeof window !== "undefined";

  const getDimensions = useCallback(() => {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  }, [hasWindow]);

  const [dimensions, setDimensions] = useState(getDimensions());

  useEffect(() => {
    if (hasWindow) {
      const handleResize = () => {
        setDimensions(getDimensions());
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [hasWindow, getDimensions]);

  return dimensions;
}
